import React from 'react'

export default function Wishlist() {
  return (
    <div>Wishlist</div>
  )
}
